import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import clsx from "clsx";
import { Tooltip } from "./Tooltip";
import s from "./IconButton.module.css";

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "aria-label"> {
  /** Required: names the action for screen readers and the tooltip. */
  label: string;
  shortcut?: string;
  icon: ReactNode;
  size?: "sm" | "md";
  pressed?: boolean;
  tooltipSide?: "top" | "right" | "bottom" | "left";
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, shortcut, icon, size = "md", pressed, tooltipSide, className, type = "button", ...rest },
  ref,
) {
  return (
    <Tooltip content={label} shortcut={shortcut} side={tooltipSide}>
      <button
        ref={ref}
        type={type}
        aria-label={label}
        aria-pressed={pressed}
        className={clsx(s.button, s[size], className)}
        {...rest}
      >
        {icon}
      </button>
    </Tooltip>
  );
});
